































































































































import { Component, Vue, Config, BasePage, Model, Watch, Prop } from "@/common";
import { TwTable } from "@/components";
import itemfetch from "./itemfetch.vue";
import { join } from "path";
@Component({
  components: {
    itemfetch
  }
})
export default class BillEdit extends BasePage {
  @Model("change", { type: Boolean })
  private value!: boolean;

  @Watch("value")
  onValueChange(val) {
    this.showEdit = val;
  }

  @Watch("showEdit")
  onshowEditChange(val) {
    if (val === false) {
      this.resetForm("headForm");
    }
    this.$emit("change", this.showEdit);
  }

  @Watch("dataLoading")
  ondataLoadingChange(val) {
    if (val === false) {
      if (this.head) {
        console.log("dataLoading");
        this.$nextTick(() => {
          this.editTable.startEditing(-1);
        });
      }
    }
  }

  @Prop({
    default: () => {
      return {
        SendLocal: null,
        TransDate: new Date().toDateString(),
        Dept: "青阳本部",
        SeqNo: null,
        InvoiceDate: null,
        InvoiceAmount: null,
        Buyer: null,
        CarNo: null,
        Status: 1
      };
    }
  })
  private head!: object;

  @Prop({ default: false })
  private dataLoading!: boolean;

  @Prop({})
  private data!: Array<any>;

  get showMask() {
    return this.dataLoading;
  }

  get editTable(): TwTable {
    return this.$refs["editTable"] as TwTable;
  }

  showEdit = false;

  saveMask = false;

  showFetch = false;

  columns = [];

  gnames = [{ label: "盘螺", value: "盘螺" }];

  gmodels = [{ label: "8", value: "8" }];

  gtextures = [{ label: "HRB400", value: "HRB400" }];

  gorigins = [{ label: "新三洲", value: "新三洲" }];

  rules = {
    SendLocal: [{ required: true, message: "请选择发货仓库", trigger: "blur" }],
    TransDate: [{ required: true, message: "请输入开单日期", trigger: "blur" }],
    Buyer: [{ required: true, message: "请输入购货单位", trigger: "blur" }]
  };

  renderHeader(h, params) {
    return (
      <span
        style="cursor:pointer"
        onClick={() => {
          this.add(); // 合并编辑:表体添加事件
        }}
      >
        {params.column.label}
        <i class="el-icon-add" style="margin-left:10px;color:green" />
      </span>
    );
  }

  afterGCountChange(newV, oldV, row) {
    if (!isNaN(newV)) {
      row.GWeight = newV * 2;
      row.BillWeight = newV * 2;
    }
    if (!isNaN(row.BillWeight) && !isNaN(row.Price)) {
      row.Amount = row.BillWeight * row.Price;
    } else {
      row.Amount = null;
    }
  }

  afterGWeightChange(newV, oldV, row) {}

  afterPriceChange(newV, oldV, row) {
    if (!isNaN(row.BillWeight) && !isNaN(newV)) {
      row.Amount = row.BillWeight * newV;
    } else {
      row.Amount = null;
    }
  }

  afterBillWeightChange(newV, oldV, row) {
    if (!isNaN(row.Price) && !isNaN(newV)) {
      row.Amount = row.Price * newV;
    } else {
      row.Amount = null;
    }
  }

  deleteData = [];

  add() {
    this.editTable.addNewRow({
      z: null,
      SeqNo: "",
      GName: "",
      GModel: "",
      GTexture: "",
      GOrigin: "",
      GCount: 0,
      GWeight: 0,
      Price: 0,
      Amount: 0,
      BillWeight: 0
    });
    this.$nextTick(() => {
      this.editTable.startEditing(-1);
    });
  }

  // 通过列渲染方式实现之定义列
  renderOperation(props) {
    return (
      <div style="display:inline;">
        <el-button
          style="padding:7px;"
          type="danger"
          onClick={() => {
            this.$confirm(`确定删除当前数据么?`, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                this.editTable.deleteRow(props.$index);
                if (props.row.ID) {
                  let row = props.row;
                  delete row.$editable;
                  this.deleteData.push(row);
                }
              })
              .catch(() => {});
          }}
        >
          删除
        </el-button>
      </div>
    );
  }

  Save() {
    this.isFormValid("headForm", valid => {
      if (valid) {
        this.saveMask = true;
        this.$http
          .post("Biz/Bill/Save", {
            head: this.head,
            list: this.editTable.getData(),
            dels: this.deleteData
          })
          .then(res => {
            if (res.data.status === 0) {
              this.saveMask = false;
              this.$message.success("保存成功");
              this.showEdit = false;
              this.$emit("on-ok");
            } else {
              this.saveMask = false;
              this.$message.warning(res.data.msg || "保存失败");
            }
          })
          .catch(err => {
            this.saveMask = false;
            this.$message.warning(err);
          });
      }
    });
  }

  fetch() {
    this.showFetch = true;
  }

  ok(seqnos) {
    console.log(seqnos);
    this.$http
      .get("/Bill/GetListData", { params: { seqnos: seqnos.join(",") } })
      .then(res => {
        const keys = this.editTable.getData().map(item => {
          return {
            ConSeqNo: item.ConSeqNo,
            ConListID: item.ConListID
          };
        });

        this.editTable.addNewRow(
          res.data.data.filter(item => {
            let existsFlag = false;
            for (let index = 0; index < keys.length; index++) {
              if (
                keys[index].ConSeqNo === item.ConSeqNo &&
                keys[index].ConListID == item.ConListID
              ) {
                existsFlag = true;
                break;
              }
            }
            return !existsFlag;
          }),
          true
        );
        this.showFetch = false;
      });
  }

  mounted() {
    this.showEdit = this.value;
    this.buildColumn("BillEdit", this.columns);
  }
}
